import { Molecule, wrap } from 'AppReact';
import styled from 'styled-components';
import { Button } from './atoms';
import { UserSvg } from 'components/icons';
import { Icon } from 'atoms';
import { Mr1 } from 'wrappers';

const template = styled.div`
  display: flex;
  align-items: center;

`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: wrap(Icon, Mr1),
      name: 'Icon',
      displayValue: ({ }) => UserSvg({ width: 16, height: 16, color: window?.settings?.primary_color ?? '#1DBD6B' })
    },
    {
      component: Button,
      name: 'Button',
      displayValue: ({ title }) => title,
      displayState: ({ disabled, mobileSmall }) => ({ disabled, mobileSmall }),
    },
  ]
})